/* eslint-disable no-console */
export const { log, error, warn, info } = console;
